import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import JoditEditor from 'jodit-react';
import {
  editUserStoreProduct
} from 'redux/actions/products';


const config = {
  'showXPathInStatusbar': false,
  'spellcheck': false,
  'askBeforePasteHTML': false,
  'askBeforePasteFromWord': false,
  'disablePlugins': 'table,preview,table-keyboard-navigation,video,file,add-new-line,about,class-span,focus,delete,wrap-text-nodes,copy-format,clipboard,drag-and-drop,drag-and-drop-element,error-messages,format-block,fullsize,hotkeys,iframe,indent,hr,inline-popup,justify,limit,link,mobile,ordered-list,placeholder,redo-undo,resizer,search,select,size,resize-handler,source,stat,sticky,symbols,tooltip,xpath',
  'buttons': 'bold,italic,underline,strikethrough,fontsize,brush,ul,ol,image'
};

const CertifiedInfo = ({product}) => {
  const dispatch = useDispatch();
  const { stores = [] } = useSelector((state) => state.user.profile);
  const info = product.custom_attributes?.find((a) => a.attribute_code === 'certifiedinfo')?.value;
  const magentoImgUrlRegex = new RegExp(/url\s*=\s*"(.+?)"/);
  const magentoImgSrcRegex = new RegExp(/src\s*=\s*"(.+?)}}"/);
  const certifiedImgSrcRegex = new RegExp(/src\s*=\s*"(.+?)"/);
  const pathForUrlRegex = new RegExp(/medias*\s*(.+?)"/);
  const getImageWidth = new RegExp(/( width\s*=\s*["'](.*?)["'])/g);
  let validatedInfo = info;

  if (info?.includes('img')) {
    const matchUrl = magentoImgUrlRegex.exec(info);
    const matchImgSrc = magentoImgSrcRegex.exec(info);
    const defaultSrcForImg = certifiedImgSrcRegex.exec(info);
    const imgSrc = matchUrl ? `src="${stores[0]?.storeUrl}/media/${matchUrl[1]}"` : defaultSrcForImg[0];

    matchImgSrc ? validatedInfo = info.replace(matchImgSrc[0], imgSrc) : validatedInfo = info.replace(imgSrc, imgSrc);
  }

  const editProductCertifiedInfo = (newContent) => {
    let newInfo = newContent;

    if (newContent.includes('img')) {
      const matchNewSrc = certifiedImgSrcRegex.exec(newContent);
      const matchNewPath = pathForUrlRegex.exec(newContent);
      const srcForStoreImg = matchNewPath ? `src="{{media url="${matchNewPath[1]}"}}"` : matchNewSrc[0];
      newInfo = newContent.replace(matchNewSrc[0], srcForStoreImg);
      newInfo = newInfo.replace(getImageWidth, 'style="max-width:200px"');
    }

    const isSertifiedInfoAttr = product.custom_attributes.filter((a) => a.attribute_code === 'certifiedinfo');

    const updatedProduct = isSertifiedInfoAttr.length ?
      {custom_attributes: product.custom_attributes.map((a) => a.attribute_code === 'certifiedinfo' ? {...a, value: newInfo} : a)}
      : {custom_attributes: [
        ...product.custom_attributes,
        {
          attribute_code: 'certifiedinfo',
          value: newInfo
        }
      ]};
    dispatch(editUserStoreProduct(updatedProduct));
  };

  return (
    <div className="w-full">
      <JoditEditor
        value={validatedInfo}
        config={config}
        tabIndex={1}
        onBlur={(newContent) => editProductCertifiedInfo(newContent)} // preferred to use only this option to update the content for performance reasons
      />
    </div>
  );
};


export default CertifiedInfo;
